webpackJsonp([7],{

/***/ "1Wuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return viewer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getImgUrl__ = __webpack_require__("5Oux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__("wszR");



var viewer = {
  getImgUrl: __WEBPACK_IMPORTED_MODULE_0__getImgUrl__["a" /* getImgUrl */],
  init: __WEBPACK_IMPORTED_MODULE_1__init__["a" /* init */]
};

/***/ }),

/***/ "2/Dm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return swiper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__imgResize__ = __webpack_require__("Ckst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__("Hzht");



var swiper = {
  init: __WEBPACK_IMPORTED_MODULE_1__init__["a" /* init */],
  imgResize: __WEBPACK_IMPORTED_MODULE_0__imgResize__["a" /* imgResize */]
};

/***/ }),

/***/ "5HLE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Oux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getImgUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_constants_index__ = __webpack_require__("5LvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_utils_index__ = __webpack_require__("EgtA");








function getImgUrl() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, options);

  if (!(argsInit(options) && argsValidate(options))) {
    return false;
  }

  var _options = options,
      imgs = _options.imgs;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {

    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(imgs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var img = _step.value;

      img.setAttribute(__WEBPACK_IMPORTED_MODULE_3_js_constants_index__["e" /* propertyName */].viewer.hdUrl, img.getAttribute('src').replace(__WEBPACK_IMPORTED_MODULE_3_js_constants_index__["c" /* imgRegExp */].hdUrlFilter, ''));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return true;
}

function argsInit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imgs = options.imgs;


  if (typeof imgs === 'string') {
    var obj = document.querySelectorAll(imgs);

    if (obj.length === 0) {
      __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e('[viewer][getImgUrl][argsInit] DOM element whose selector\'s ' + wrapper + ' not found.');
      return false;
    }

    options.imgs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(obj);
  }

  return true;
}

function argsValidate() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imgs = options.imgs;

  var from = '[viewer][getImgUrl][argsValidate]';

  if (imgs instanceof Array) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(imgs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var img = _step2.value;

        if (!(img instanceof Image)) {
          __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e(from + ' img isn\'t an instance of Image.');
          return false;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e(from + ' imgs isn\'t an instance of Array.');
    return false;
  }

  return true;
}

/***/ }),

/***/ "Ckst":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = imgResize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_utils_index__ = __webpack_require__("EgtA");








function imgResize() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, options);

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!(argsInit(options) && argsValidate(options))) {
      return reject();
    }

    var _options = options,
        imgs = _options.imgs,
        ht = _options.ht;

    var maxLen = imgs.length;
    var cnt = 0;

    var timer = setInterval(function () {
      var _loop = function _loop(img) {
        if (img.complete) {
          if (typeof img.naturalWidth !== 'undefined') {
            var ratio = img.naturalWidth / img.naturalHeight;
            var wt = void 0;
            var height = void 0;
            var unit = void 0;

            if (ratio > 1) {
              height = ht.horiz.value;
              unit = ht.horiz.unit;
            } else {
              height = ht.verti.value;
              unit = ht.verti.unit;
            }

            wt = (height * ratio).toFixed(3) * 1000 / 1000;

            $(img).css({
              'width': '' + wt + unit,
              'height': '' + height + unit
            });
            $(img).parent('.swiper-slide').css({
              'width': '' + wt + unit
            });

            var index = imgs.findIndex(function (ele) {
              return img === ele;
            });
            imgs.splice(index, 1);
            cnt++;
          } else {
            __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e('[posterInit] failed: 浏览器不支持 naturalWidth 属性');
            reject();
            clearInterval(timer);
            return 'break';
          }
        }

        if (cnt >= maxLen) {
          resolve();
          clearInterval(timer);
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(imgs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var img = _step.value;

          var _ret = _loop(img);

          if (_ret === 'break') break;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }, 300);
  });
}

function argsInit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imgs = options.imgs,
      _options$ht = options.ht,
      ht = _options$ht === undefined ? {
    horiz: {
      value: 8.75,
      unit: 'rem'
    },
    verti: {
      value: 12.75,
      unit: 'rem'
    }
  } : _options$ht;


  options.ht = ht;

  if (typeof imgs === 'string') {
    var obj = document.querySelectorAll(imgs);

    if (obj.length === 0) {
      __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e(from + '[argsInit] DOM element whose selector\'s ' + imgs + ' not found.');
      return false;
    }

    options.imgs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(obj);
  }

  if ((typeof ht === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(ht)) === 'object') {
    options.ht = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({
      horiz: {
        value: 8.75,
        unit: 'rem'
      },
      verti: {
        value: 12.75,
        unit: 'rem'
      }
    }, ht);
  }

  return true;
}

function argsValidate() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imgs = options.imgs,
      ht = options.ht;

  var from = '[swiper][imgResize][argsValidate]';

  if (imgs instanceof Array) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(imgs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var img = _step2.value;

        if (!(img instanceof HTMLElement)) {
          __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e(from + ' img is not an instance of Image.');
          return false;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e(from + ' imgs is not an instance of Array.');
    return false;
  }

  if ((typeof ht === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(ht)) !== 'object') {
    __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e(from + ' invalid argument ht.');
    return false;
  }

  return true;
}

/***/ }),

/***/ "Hzht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);



function init() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$selector = _ref.selector,
      selector = _ref$selector === undefined ? '.swiper-container' : _ref$selector,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? {} : _ref$options;

  var opts = {
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    initialSlide: 0,
    observer: true,
    observeParents: true,
    paginationElement: 'li',
    resistance: true,
    resistanceRatio: 0.85
  };
  var objArr = [];

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(opts, options);

  if (!(selector instanceof Array) && typeof selector !== 'string') {
    return utils.log.e('[swiper][init] invalid argument: selector', selector);
  }

  if (selector instanceof Array) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selector), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var obj = _step.value;

        obj = new Swiper(obj, opts);
        objArr.push(obj);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else {
    objArr.push(new Swiper(selector, opts));
  }

  return objArr;
}

/***/ }),

/***/ "iu1/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_index__ = __webpack_require__("2/Dm");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__swiper_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__viewer_index__ = __webpack_require__("1Wuk");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__viewer_index__["a"]; });



/***/ }),

/***/ "wszR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_constants_index__ = __webpack_require__("5LvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_utils_index__ = __webpack_require__("EgtA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getImgUrl__ = __webpack_require__("5Oux");








function init() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options);

  if (!(argsInit(options) && argsValidate(options))) {
    return false;
  }

  var _options = options,
      wrapper = _options.wrapper;

  var viewer = new Viewer(wrapper, {
    url: __WEBPACK_IMPORTED_MODULE_1_js_constants_index__["e" /* propertyName */].viewer.hdUrl
  });

  return viewer;
}

function argsInit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var from = '[viewer][init]';

  if (!__WEBPACK_IMPORTED_MODULE_2_js_utils_index__["b" /* args */].init.selector({
    args: options,
    from: from,
    name: 'wrapper'
  })) {
    return false;
  }

  return true;
}

function argsValidate() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var from = '[viewer][init]';

  if (!__WEBPACK_IMPORTED_MODULE_2_js_utils_index__["b" /* args */].validate.instance({
    args: options,
    from: from,
    name: 'wrapper'
  })) {
    return false;
  }

  return true;
}

/***/ }),

/***/ "y9mV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_page_game_scss__ = __webpack_require__("5HLE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_page_game_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_css_page_game_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_constants_index__ = __webpack_require__("5LvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_common_index__ = __webpack_require__("4PxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_animation_index__ = __webpack_require__("iu1/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_utils_index__ = __webpack_require__("EgtA");












function articleListInit() {
  var obj = document.querySelector('.article');
  if (!obj) {
    __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e('[articleListInit] DOM element whose selector\'s .article not found.');
    return;
  }

  var tagList = obj.querySelector('.tag-container');
  if (tagList && tagList.children.length === 0) {
    $(obj).remove();
  }

  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["g" /* blkNavTag */].init({
    aTag: obj.querySelector('.top-rt a'),
    tagList: tagList,
    blkList: obj.querySelector('.list-containers')
  });
}

function bindEvts() {
  console.log('game.js bindevt');

  console.log("初始化下载按钮");

  downGameBtnInit();

  articleListInit();

  memberFormInit();

  swipersInit();

  commentEvtsInit();

  console.log('bindEvts 完成');
}

function downGameBtnInit() {
  $('.yui-qrbtn0').click(function () {
    console.log("点击下载游戏");

    var user = __WEBPACK_IMPORTED_MODULE_3_js_common_index__["i" /* dataBus */].get('user');
    if (!user) {
      return __WEBPACK_IMPORTED_MODULE_3_js_common_index__["o" /* message */].common.pleaseLogin({
        callback: function callback() {
          var obj = document.querySelector('header a.login');
          if (obj) {
            obj.click();
          }
        },
        mode: 1
      });
    } else {
      if (user.idcard == '') {
        console.log("登录成功，没有实名认证过。所以显示实名");

        __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].showRealName({
          form: '.yui-memberform0-login'
        });
      } else {
        console.log("已经实名认证了");

        var data = $('.yui-qrbtn0').attr('data-href');
        console.log("下载地址");
        console.log(data);
        window.location.href = data;
      }
    }
  });
}

function commentEvtsInit() {
  var maskObj = document.querySelector('.mask-cmmt');

  if (!maskObj) {
    __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e('[commentEvtsInit] DOM element whose selector\'s .mask-cmmt not found.');
    return;
  }

  var gameId = "";

  if (document.querySelector('.sec-cmmt') != null) {
    gameId = document.querySelector('.sec-cmmt').getAttribute(__WEBPACK_IMPORTED_MODULE_2_js_constants_index__["a" /* api */].gameIdPropertyName);
  }

  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].publishInit({
    badBtn: maskObj.querySelector('.yui-icon-cry0-yellow').parentNode,
    cancelBtn: '.yui-ccmmt-publish0 .btn-op.cancel',
    cancelSuccess: hideMask,
    data: {
      gameId: gameId
    },
    goodBtn: maskObj.querySelector('.yui-icon-smile0-yellow').parentNode,
    ipt: '.yui-ccmmt-publish0 textarea',
    submitBtn: '.yui-ccmmt-publish0 .btn-op.push',
    submitSuccessBefore: function submitSuccessBefore() {
      return window.location.href = window.location.href;
    },
    submitFinally: hideMask
  });

  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].thumbInit({
    list: '.cmmt-blk',
    btnSelector: '.btn-thumb'
  });

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(document.querySelectorAll('.sec-cmmt .yui-thumbbtn0')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var o = _step.value;

      o.addEventListener('click', showMask, false);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  function showMask() {
    if (!maskObj) {
      __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e('[commentEvtsInit][showMask] DOM element whose selector\'s .mask-cmmt not found.');
      return;
    }

    var user = __WEBPACK_IMPORTED_MODULE_3_js_common_index__["i" /* dataBus */].get('user');
    if (!user) {
      return __WEBPACK_IMPORTED_MODULE_3_js_common_index__["o" /* message */].common.pleaseLogin({
        callback: function callback() {
          var obj = document.querySelector('header a.login');
          if (obj) {
            obj.click();
          }
        },
        mode: 1
      });
    }

    var obj = this.querySelector('.yui-icon-smile0-yellow');
    if (obj) {
      $('.mask-cmmt .yui-icon-cry0-yellow').toggleClass('yui-icon-cry0-yellow yui-icon-cry0-gray');
    }

    obj = this.querySelector('.yui-icon-cry0-yellow');
    if (obj) {
      $('.mask-cmmt .yui-icon-smile0-yellow').toggleClass('yui-icon-smile0-yellow yui-icon-smile0-gray');
    }

    maskObj.style.display = 'block';
  }

  function hideMask() {
    if (!maskObj) {
      __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e('[commentEvtsInit][hideMask] DOM element whose selector\'s .mask-cmmt not found.');
      return;
    }

    var obj = maskObj.querySelector('.yui-icon-smile0-yellow, .yui-icon-smile0-gray');
    if (obj) {
      $(obj).addClass('yui-icon-smile0-yellow').removeClass('yui-icon-smile0-gray');
    }

    obj = maskObj.querySelector('.yui-icon-cry0-yellow, .yui-icon-cry0-gray');
    if (obj) {
      $(obj).addClass('yui-icon-cry0-yellow').removeClass('yui-icon-cry0-gray');
    }

    maskObj.querySelector('textarea').value = '';
    maskObj.style.display = 'none';
  }
}

function cmmtUIInit() {
  var maskObj = document.querySelector('.mask-cmmt');
  if (maskObj == null) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].loadCmmtList({
    mode: 0,
    params: {
      desc: '.desc-load',
      id: '.sec-cmmt',
      pageList: '.yui-pagination0 .pagelist',
      target: '.sec-cmmt .cmmt-blk'
    }
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].loadGood({
    bad: '.txt-add.bad',
    data: {
      gameId: document.querySelector('.sec-cmmt').getAttribute(__WEBPACK_IMPORTED_MODULE_2_js_constants_index__["a" /* api */].gameIdPropertyName)
    },
    good: '.txt-add.good'
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].loadUserData({
    avatar: '.yui-ccmmt-top0 .avatar img',
    mode: 1,
    mode1Callback: function mode1Callback() {
      var obj = document.querySelector('header a.login');
      if (obj) {
        obj.click();
      }
    },
    userName: '.yui-ccmmt-top0 .avatar .username'
  });
}

function memberFormInit() {
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].closeForm.init();
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].loginFormInit({
    success: function success() {
      window.location.href = window.location.href;
    },
    form: '.yui-memberform0-login',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member'
  });

  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].realNameFormInit({
    form: '.yui-memberform0-real-name',
    mask: '.mask-member'
  });
}

function swipersInit() {
  __WEBPACK_IMPORTED_MODULE_4_js_animation_index__["a" /* swiper */].init({
    selector: '.swiper0',
    options: {
      autoplay: false,
      slidesPerView: 'auto',
      navigation: {
        prevEl: '.swiper0 .prev-el',
        nextEl: '.swiper0 .next-el'
      }
    }
  });
}

function screenshotInit() {
  __WEBPACK_IMPORTED_MODULE_4_js_animation_index__["a" /* swiper */].imgResize({
    imgs: '.swiper0 .swiper-slide img',
    ht: {
      horiz: {
        value: 300,
        unit: 'px'
      },
      verti: {
        value: 390,
        unit: 'px'
      }
    }
  }).then(function () {
    swipersInit();

    if (!__WEBPACK_IMPORTED_MODULE_4_js_animation_index__["b" /* viewer */].init({
      wrapper: '.swiper0 .swiper-wrapper'
    })) {
      return;
    }

    __WEBPACK_IMPORTED_MODULE_4_js_animation_index__["b" /* viewer */].getImgUrl({
      imgs: '.swiper-slide img'
    });
  }).catch(function (e) {
    if (e && e.message) {
      __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e(e.message);
    }
  });
}

function QRCodeInit() {
  var parser = new __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["a" /* UrlParser */]();

  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["q" /* qrcode */].init({
    ht: 140,
    prefix: parser.domainName,
    target: '.yui-qrbtn0 .qrcode',
    wt: 140
  });
}

function showMoreIntro() {
  Object(__WEBPACK_IMPORTED_MODULE_3_js_common_index__["r" /* showMore */])({
    container: '.introduce .content > div',
    dpBtn: '.btn-dp',
    hBtn: '.btn-hide',
    jsJump: true,
    limitValue: 3,
    mode: 'line'
  });
}

function uiInit() {

  showMoreIntro();

  screenshotInit();

  cmmtUIInit();
}

window._dataBus.get('domReadyObserver').subscribe(function () {
  console.log("dom 完毕 详情页收到广播 ");
  uiInit();
  bindEvts();
});

/***/ })

},["y9mV"]);


// WEBPACK FOOTER //
// js/game.js